import { makeStyles, Theme } from '@material-ui/core/styles';

const styles = makeStyles((theme: Theme) => ({
  icons: {
    position: 'relative',
    top: '6px',
  },
  columnWidthCheckboxes: {
    width: '80px',
  },
  columnWidth: {
    // width: '330px',
  },
  borderBottom: {
    borderBottom: 'none',
  },
  availabilityFilterLabel: {
    textTransform: 'none',
  },
  availabilityButton: {
    cursor: 'text',
    fontSize: 16,
    color: theme.palette.constrastGreyDark.main,
    height: 40,
    float: 'left',
    marginTop: 10,
    marginBottom: 10,
  },
  divFilters: {
    display: 'flex',
    justifyContent: 'flex-end',
    '& > button': {
      marginRight: '50px',
    },
    '& > div': {
      marginRight: '50px',
    },
  },
  divGroups: {
    marginLeft: '27px',
  },
  divItems: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: 'left',
    color: theme.palette.text.secondary,
    height: '20vh',
    overflow: 'auto',
  },
  root: {
    flexGrow: 1,
  },
  chipInput: {
    maxHeight: 60,
    overflow: 'auto',
  },
  appBar: {
    backgroundColor: theme.palette.appBarsColor.main,
  },
  holdingProfilesTabs: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
    display: 'flex',
  },
  flexSpaceBetween: {
    display: 'flex',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
  },
  tabs: {
    color: theme.palette.constrastGreyBlack.main,
  },
}));

export default styles;
